// extracted by mini-css-extract-plugin
export default {"tabletImg":"hH","desktopImg":"iH","mobileImg":"jH","backgroundImage":"kH","content":"lH","rtbLeft":"mH","rtbRight":"nH","imageContainer":"oH","rtbBox":"pH","line":"qH"};
    if(module.hot) {
      // 1711717533682
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  